var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-select',{attrs:{"outlined":"","label":"Filter by Priority","items":_vm.items,"multiple":"","chips":"","small-chips":"","item-color":"primary","clearable":""},on:{"change":_vm.onFilterChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }